import { type QueryClient, useQuery } from "@tanstack/react-query";
import { listCareFormDetailRecords } from "../utils/storage";
import { useCacheStorage } from "@/setup/frontend/storage/CacheStorageContext";

export function useOfflineCareForms() {
	const storage = useCacheStorage();
	return useQuery({
		queryKey: ["offline-care-forms"],
		queryFn: () => listCareFormDetailRecords(storage),
		networkMode: "always",
		refetchOnMount: true,
		staleTime: 0,
	});
}

export function invalidateOfflineCareForms(queryClient: QueryClient) {
	queryClient.invalidateQueries({
		queryKey: ["offline-care-forms"],
	});
}
